import React, { useContext, useState } from "react";
import { Td, Tooltip, Tr } from "@chakra-ui/react";
import MenuRUD from "components/Menu/MenuRUD";
import styled from "styled-components";
import { IconGeneric } from "styled/Icons.styled";
import { BsCheckCircleFill } from "react-icons/bs";
import {
  __ACTIVAR,
  __DESACTIVAR
} from "request/configuration/__Activar_Desactivar";
import environment from "constants/apiConst";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useSelector } from "react-redux";
import { __ShowGroup } from "request/configuration/__ShowGroup";
import { ConfigIconStatus } from "./components/LoadingConfig";

const TdState = styled(Td)`
  color: ${(props) => (props.text === 1 ? "#58D68D" : "#F1948A")};
`;

const TbodyGroup = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const { setUpdate, update, setLoading } = useContext(
    ConfigurationCRUDContext
  );
  const [openAlert] = AlertErrorAlert();
  const [loadingIcons, setLoadingIcons] = useState(false);

  const desactivarAndActivar = async (result) => {
    setLoading(true);
    try {
      const resultado =
        result === 1
          ? await __DESACTIVAR(token, environment.GROUP_DESACTIVE, data.id)
          : await __ACTIVAR(token, environment.GROUP_ACTIVE, data.id);
      if (resultado.data.status.code !== 200) {
        openAlert(resultado.data.status.message, "error");
      } else {
        openAlert(resultado.data.status.message, "success");
        setUpdate(!update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleState = async () => {
    setLoadingIcons(true);
    try {
      const res = await __ShowGroup(token, data.id);
      const result = res.data.status.data.status_permissionGroup;
      desactivarAndActivar(result);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingIcons(false);
    }
  };

  return (
    <Tr>
      <Td className="text-center">{data?.modul_permissionGroup}</Td>
      <Td className="text-center">{data?.name_permissionGroup}</Td>
      <Td className="text-center">{data?.descriptions_permissionGroup}</Td>
      <Tooltip
        placement="top"
        hasArrow
        label={data?.status_permissionGroup === 1 ? "Desactivar" : "Activar"}
      >
        <TdState
          onClick={loadingIcons ? "" : handleState}
          className="text-center"
          isNumeric
          text={data.status_permissionGroup}
        >
          <ConfigIconStatus
            loading={loadingIcons}
            status={data?.status_permissionGroup}
          />
        </TdState>
      </Tooltip>
      <Td className="text-center">
        <MenuRUD data={data} />
      </Td>
    </Tr>
  );
};

export default TbodyGroup;
